const IconButton = ({
    onClick = () => { },
    type = "button",
    icon: IconComponent,
    bgColor = "bg-gray-200",
    iconColor = "text-white",
    size = "max-w-8 md:max-w-10 min-w-8 md:min-w-10",
    iconSize = "text-xl md:text-3xl",
    ...rest
}) => {
    return (
        <button
            className={`${bgColor} rounded-full ${size} flex justify-center items-center aspect-square md:hover:animate-tada`}
            onClick={onClick}
            type={type}
            {...rest}
        >
            <IconComponent className={`${iconSize} ${iconColor}`} />
        </button>
    );
};

export default IconButton;